const styles = {
  loaderWrapper: {
    zIndex: 100,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // position: 'fixed',
    backgroundColor: '#ffffff',
    borderRadius: '10px'
  }
};

export default styles;
